import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

const languageOptions = {
  en: { code: 'en', name: 'English (US)', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/us.svg' },
  gb: { code: 'gb', name: 'English (UK)', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/gb.svg' },
  de: { code: 'de', name: 'Deutsch', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/de.svg' },
  dk: { code: 'dk', name: 'Dansk', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/dk.svg' },
  it: { code: 'it', name: 'Italiano', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/it.svg' },
  cn: { code: 'cn', name: '中文 (繁體)', flag: 'https://static.articlesfactory.ai/app/vendor/flag-icon-css/flags/1x1/cn.svg' }
};

export const LanguageProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.setItem('language', lng);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
      setLanguage(storedLanguage);
    }
  }, [i18n]);

  return (
    <LanguageContext.Provider value={{ t, i18n, language, changeLanguage, languageOptions }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
